import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    routes: [
        {
            path: "/",
            name: "layout",
            component: () => import("@/views/home.vue"),
        },
        // {
        //     path: "/overview",
        //     name: "overview",
        //     component: () => import("@/views/overview.vue"),
        // },
        // {
        //     path: "/relic",
        //     name: "relic",
        //     component: () => import("@/views/relic.vue"),
        //     children: [
        //         {
        //             path: ":id/3d",
        //             name: "relic3d",
        //             component: () => import("@/components/Relic3d.vue"),
        //         },
        //         {
        //             path: ":id/introduce",
        //             name: "introduce",
        //             component: () => import("@/components/Introduce.vue"),
        //         },
        //         {
        //             path: ":id/profile",
        //             name: "profile",
        //             component: () => import("@/components/Profile.vue"),
        //             children: [
        //                 {
        //                     path: "document",
        //                     name: "document",
        //                     component: () =>
        //                         import("@/components/profile-detail/List.vue"),
        //                 },
        //                 {
        //                     path: "document/:idDocument",
        //                     name: "documentDetail",
        //                     component: () =>
        //                         import(
        //                             "@/components/profile-detail/Detail.vue"
        //                         ),
        //                 },
        //                 {
        //                     path: "film",
        //                     name: "film",
        //                     component: () =>
        //                         import("@/components/profile-detail/List.vue"),
        //                 },
        //                 {
        //                     path: "film/:idFilm",
        //                     name: "filmDetail",
        //                     component: () =>
        //                         import(
        //                             "@/components/profile-detail/Detail.vue"
        //                         ),
        //                 },
        //                 {
        //                     path: "law",
        //                     name: "law",
        //                     component: () =>
        //                         import("@/components/profile-detail/List.vue"),
        //                 },
        //                 {
        //                     path: "law/:idLaw",
        //                     name: "lawDetail",
        //                     component: () =>
        //                         import(
        //                             "@/components/profile-detail/Detail.vue"
        //                         ),
        //                 },
        //                 {
        //                     path: "survey",
        //                     name: "survey",
        //                     component: () =>
        //                         import("@/components/profile-detail/List.vue"),
        //                 },
        //                 {
        //                     path: "survey/:idSurvey",
        //                     name: "surveyDetail",
        //                     component: () =>
        //                         import(
        //                             "@/components/profile-detail/Detail.vue"
        //                         ),
        //                 },
        //                 {
        //                     path: "certificate",
        //                     name: "certificate",
        //                     component: () =>
        //                         import("@/components/profile-detail/List.vue"),
        //                 },
        //                 {
        //                     path: "certificate/:idCertificate",
        //                     name: "certificateDetail",
        //                     component: () =>
        //                         import(
        //                             "@/components/profile-detail/Detail.vue"
        //                         ),
        //                 },
        //             ],
        //         },
        //     ],
        // },
        {
            path: "/experience",
            name: "experience",
            component: () => import("@/views/experience.vue"),
        },
    ],
});

export default router;
